import { create as MathJsCreate, all as MathJsAll } from 'mathjs'
import { Plugins } from '@leverege/plugin'

// const AttributeRegEx = / @[a-zA-Z0-9.$]+/g

function processor( plgs ) {
  const math = MathJsCreate( MathJsAll )
  plgs.forEach( ( plg ) => { 
    math.import( 
      plg.getFunctions(), {
        override : plg.override || false,
        silent : plg.silent || false,
        wrap : plg.wrap || false
      } )
  } )
  const currEq = math.equal   
  math.import( {
    // This equals will allow for string equals via '==' as well as number to
    // string coersion. It also seems to allow variable whose value is a unit ( like "32 m" )
    // to work with unit comparisons: ${value} == 32 m. Does not work with smallerEq thought
    equal( a, b ) { 
      try {
        if ( currEq( a, b ) ) {
          return true
        }
      } catch ( ex ) { }
      // eslint-disable-next-line eqeqeq
      return a == b 
    }
  }, { override : true } )
  
  return math
}

const math = Plugins.createView( 'condition.ExpressionImports', { name : 'default', processor } )
const preprocessors = Plugins.createView( 'condition.ExpressionPreprocessor', { name : 'default', sort : 'byNumber' } )

// math.import( {
//   attr : ( name, obj ) => {
//     return 555
//   }
// } )
// math.import( {
//   equal( a, b ) { return a === b } 
// }, { override : true } )

export default class Expression {

  constructor( expression ) {
    
    // Replace Attribute queries with function names.
    let exp = expression || ''
    const processors = preprocessors.get()
    for ( let n = 0; n < processors.length; n++ ) {
      exp = processors[n]( exp )
    }
    // const matches = [ ...expression.matchAll( AttributeRegEx ) ]
    // for ( let n = matches.length - 1; n >= 0; n-- ) {
    //   const m = matches[n]
    //   const len = m[0].length
    //   const idx = m.index
    //   const fnc = `attr( "${m[0].slice( 1 )}", target )`
    //   exp = exp.substring( 0, idx ) + fnc + exp.substring( idx + len )
    // }

    // We could check to make sure we are not overwriting values in scope. 
    // this.node = math.get().create().parse( exp )
    try {
      this.compiled = math.get().compile( exp )
      this.error = null
    } catch ( ex ) {
      this.error = ex
    }
  }

  isValid() {
    return this.error != null
  }

  eval( scope ) {
    const r = this.compiled.evaluate( scope )
    if ( r && r.isResultSet === true ) {
      return r.valueOf()
    }
    return r
  }
}
